import {IdentityUser, TenantDto} from "@/@types/auth.types.ts";
import {create} from "zustand";
import {persist} from "zustand/middleware";

type UserState = {
    user?: IdentityUser;
    isAuthenticated: boolean;
    setUser: (user?: IdentityUser) => void;
    tenant?: TenantDto;
    setTenant: (tenant?: TenantDto) => void;
    setAuthenticated: (isAuthenticated: boolean) => void;
}

export const useAuthUser = create<UserState>()(
    persist(
        (set) => ({
            user: undefined,
            isAuthenticated: false,
            tenant: undefined,
            setUser: (user?: IdentityUser) => set({user}),
            setAuthenticated: (isAuthenticated: boolean) => set({isAuthenticated}),
            setTenant: (tenant?: TenantDto) => set({tenant}),
        }),
        {
            name: "owninn-portal-user-storage-4b4ddfd2-3369-4ff6-adb3-03d6c4642afb",
            //@ts-ignore
            getStorage: () => localStorage,
        }
    )
);